"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN_CHANGED = exports.PROVIDER_CHANGED = exports.ADDRESS_CHANGED = exports.MANIFOLD_ETHEREUM_EXISTS = exports.MANIFOLD_ETHEREUM_INITIALIZED = exports.EthereumProviderErrorName = void 0;
var EthereumProviderErrorName;
(function (EthereumProviderErrorName) {
    EthereumProviderErrorName["EthereumProviderMultipleChains"] = "EthereumProviderMultipleChains";
    EthereumProviderErrorName["WindowEthereumConnectionError"] = "WindowEthereumConnectionError";
})(EthereumProviderErrorName = exports.EthereumProviderErrorName || (exports.EthereumProviderErrorName = {}));
exports.MANIFOLD_ETHEREUM_INITIALIZED = 'manifold-ethereum-initialized';
exports.MANIFOLD_ETHEREUM_EXISTS = 'manifold-ethereum-exists';
exports.ADDRESS_CHANGED = 'ethereum-address-changed';
exports.PROVIDER_CHANGED = 'frontend-provider-changed';
exports.CHAIN_CHANGED = 'frontend-provider-chain-changed';
